// import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import style from './share-tip.css';
import CheckboxButton from '../checkbox-button/checkbox-button.jsx';
import CloseButton from '.././share-modal/close-button.jsx';
import ReactModal from 'react-modal';
import bindAll from 'lodash.bindall';
import close from '../../assets/close.png';

class DeviceDetection extends React.Component {
    constructor (props) {
        super(props);
        
        bindAll(this, [
            'handleHideShareTip'
        ]);

        this.state = {
            shareTipShow: false
        };
    }
    componentDidMount () {
        const storageShareTipShowTimes = window.localStorage.getItem('shareTipShowTimes');
        const shareTipShowTimes = storageShareTipShowTimes ? JSON.parse(storageShareTipShowTimes) : [];
        const date = new Date().toLocaleDateString();
        if (!shareTipShowTimes.includes(date) && shareTipShowTimes.length < 3) {
            shareTipShowTimes.push(date);
            localStorage.setItem('shareTipShowTimes', JSON.stringify(shareTipShowTimes));
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({shareTipShow: true});
        }
    }
    componentWillUnmount () {
    }
    handleHideShareTip (){
        this.setState({shareTipShow: false});
    }

    render () {
        const {shareTipShow} = this.state;
        // const {} = this.props;
        return (shareTipShow && <div
            className={style.shareTip}
        >
            <p className={style.shareTitle}>
                {'分享提示'}
                <img
                    className={style.closeIcon}
                    onClick={this.handleHideShareTip}
                    src={close}
                />
            </p>
            <p className={style.shareContent}>
                <span>{'限时'}</span>
                {'录视频分享作品，可获得20积分'}
            </p>
            <p
                className={style.shareBtn}
                onClick={this.handleHideShareTip}
            >{'知道了'}</p>
        </div>
        );
    }
}
DeviceDetection.propTypes = {
};

export default DeviceDetection;
